<template>
    <div class="patient_selection_form_inner">
        <div class="blurb_f_predication" v-if="selectedModelInfo && selectedModelInfo.blurb"
            v-html="selectedModelInfo.blurb"></div>
        <div class="predication_output_box" v-if="modelOutputData">
            <div class="predication_output_box_inner" :class="modelOutputData.output == 'malignant' ? 'radius_bg' : ''">
                <div class="row align-items-center">
                    <div class="col">
                        <h3 v-if="modelOutputData.key" class="mb-0 predication_output_heading">{{ modelOutputData.key }}
                            :
                            <span>{{ modelOutputData.output }} </span>
                        </h3>
                        <h3 v-if="modelOutputData.output_key" class="mb-0 predication_output_heading">
                            {{ modelOutputData.output_key }} : <span>{{ modelOutputData.output_data }} </span></h3>
                    </div>
                    <div class="col-auto ml-auto">
                        <button class="btn btn-success" @click="newPredictionForModelMethod">Next Patient</button>
                    </div>
                </div>
            </div>
        </div>
        <div class="model_predict_form_box">
            <div class="create_model_first_step center_container_sm" v-if="useModelFirstStep">
                <form @submit.prevent="stepFirstUseFormMethod">
                    <div class="form-group">
                        <label>Patient Name</label>
                        <input type="text" class="form-control" v-validate="'required'" v-model="patient_name"
                            name="patient_name" v-bind:class="{ 'is-invalid': errors.has('patient_name') }"
                            data-vv-as="patient name" autocomplete="off">
                        <small class="invalid-feedback" v-if="errors.has('patient_name')">{{
                            errors.first('patient_name')
                            }}</small>
                    </div>
                    <button class="btn btn-primary" type="submit" :disabled="submitted">Next</button>
                </form>
            </div>
            <div class="create_model_second_step" v-if="useModelSecondStep">
                <div class="mb-3" v-if="describeListNext"><button class="btn btn-primary" :disabled="submitted"
                        @click="nextDescribeListMethod(describeListNext)">Next</button></div>
                <form @submit.prevent="stepSecondUseFormMethod">
                    <template v-if="!readOnlyPredictionField">
                        <button class="btn btn-primary mb-3" type="submit" :disabled="submitted"
                            v-if="!describeListNext">Predict</button>
                    </template>
                    <template v-else>
                        <span class="btn btn-info edit_field_btn mb-3" @click="readOnlyDisabledMethod">Edit</span>
                    </template>
                    <span class="model_trained_loader mt-0" v-if="modelTrainedLoader"><img
                            src="@/assets/images/progressbar.gif" class="img-fluid"></span>
                    <div class="row">
                        <div v-for="(attribute, index) in predictionFilesDescribe" :key="index" class="mb-2 col-sm-4">
                            <div class="row align-items-center custom_error">
                                <div class="col-12 pr-0">
                                    <label class="text_overflow" :title="attribute.key">{{ attribute.key }}:</label>
                                </div>
                                <div class="col-12">
                                    <template v-if="attribute.validation_type == 'float64'">
                                        <input type="number" v-model="predictionFilesDescribe[index].value"
                                            :name="'label' + index" class="form-control text-center"
                                            v-validate="'required|decimal'"
                                            v-bind:class="{ 'is-invalid': errors.has('label' + index) }"
                                            autocomplete="off" step="any" :readonly="readOnlyPredictionField">
                                    </template>
                                    <template v-else-if="attribute.validation_type == 'int64'">
                                        <input type="number" v-model="predictionFilesDescribe[index].value"
                                            :name="'label' + index" class="form-control text-center"
                                            v-validate="'required|numeric'"
                                            v-bind:class="{ 'is-invalid': errors.has('label' + index) }"
                                            autocomplete="off" :readonly="readOnlyPredictionField">
                                    </template>
                                    <template v-else-if="validArrCheckOfValueMethod(attribute.validation_type)">
                                        <select class="form-control prediction_files_option_wrp"
                                            v-model="predictionFilesDescribe[index].value" v-validate="'required'"
                                            :name="'label' + index" :readonly="readOnlyPredictionField">
                                            <option v-for="(selectItem, i) in attribute.validation_type" :key="i">
                                                {{ selectItem }}
                                            </option>
                                        </select>
                                    </template>
                                    <template v-else>
                                        <input type="text" v-model="predictionFilesDescribe[index].value"
                                            :name="'label' + index" class="form-control text-center"
                                            v-validate="'required'"
                                            v-bind:class="{ 'is-invalid': errors.has('label' + index) }"
                                            autocomplete="off" :readonly="readOnlyPredictionField">
                                    </template>
                                </div>
                                <template v-if="attribute.validation_type == 'float64'">
                                    <small class="invalid-feedback mb-1 mt-0 d-block" v-if="errors.has('label' + index)"
                                        style="padding-left:15px;">The field is numeric required</small>
                                </template>
                                <template v-else-if="attribute.validation_type == 'int64'">
                                    <small class="invalid-feedback mb-1 mt-0 d-block" v-if="errors.has('label' + index)"
                                        style="padding-left:15px;">The field is numeric required</small>
                                </template>
                                <template v-else-if="validArrCheckOfValueMethod(attribute.validation_type)">
                                    <small class="invalid-feedback mb-1 mt-0 d-block" v-if="errors.has('label' + index)"
                                        style="padding-left:15px;">The field is required</small>
                                </template>
                                <template v-else>
                                    <small class="invalid-feedback mb-1 mt-0 d-block" v-if="errors.has('label' + index)"
                                        style="padding-left:15px;">The field is required</small>
                                </template>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
/*eslint-disable */

import axios from 'axios';
import toast from '@/services/toast';

export default {
    name: 'create-new-models',
    components: {},
    props: ['selectedModelInfo'],
    data() {
        return {
            useModelFirstStep: true,
            useModelSecondStep: false,
            submitted: false,
            patient_name: '',
            predictionFilesDescribe: [],
            predictionAlertState: false,
            describeListNext: null,
            modelOutputData: null,
            modelTrainedLoader: false,
            readOnlyPredictionField: false
        }
    },
    computed: {

    },
    mounted() {
    },
    methods: {
        newPredictionForModelMethod() {
            this.modelOutputData = null
            this.patient_name = ''
            this.useModelFirstStep = true
            this.useModelSecondStep = false
            this.readOnlyPredictionField = false
        },
        stepFirstUseFormMethod() {
            this.$validator.validateAll().then((result) => {
                if (result) {
                    this.submitted = true
                    this.$store.dispatch('getAttrOfTrainedForUseModelsFun', { id: this.selectedModelInfo.id }).then((res) => {
                        this.predictionFilesDescribe = res.data.data.results
                        this.describeListNext = res.data.data.next
                        this.useModelFirstStep = false
                        this.useModelSecondStep = true
                        this.submitted = false
                    })
                    return;
                }
            })
        },
        readOnlyDisabledMethod() {
            this.readOnlyPredictionField = false
        },
        nextDescribeListMethod(url) {
            this.$validator.validateAll().then((result) => {
                if (result) {
                    this.submitted = true
                    axios.get(url).then((response) => {
                        this.describeListNext = response.data.data.next
                        this.predictionFilesDescribe = [].concat(response.data.data.results, this.predictionFilesDescribe);
                        this.submitted = false
                    });
                    return;
                }
            })
        },
        predictionAllFieldCheckingFun() {
            this.$validator.validateAll().then((result) => {
                if (result) {
                    this.predictionAlertState = true
                }
            })
        },
        stepSecondUseFormMethod() {
            this.$validator.validateAll().then((result) => {
                if (result) {
                    this.submitted = true
                    this.modelTrainedLoader = true
                    let data = {
                        input_list: this.predictionFilesDescribe,
                        model: this.selectedModelInfo.id,
                        run: true,
                        patient_name: this.patient_name
                    }
                    this.$store.dispatch('modelsUsingForAiDashFun', data)
                        .then((res) => {
                            this.modelOutputData = res.data.data
                            toast.success(res.data.msg || "Request processed successfully.");
                            this.modelTrainedLoader = false
                            this.readOnlyPredictionField = true
                            this.submitted = false
                        }).catch((err) => {
                            this.modelTrainedLoader = false
                            this.submitted = false
                            toast.error(err.data.user_msg || err.data.msg);
                        })
                    return;
                }
            })
        },
        draftUsingCurrentModelsMethod() {
            let data = {
                input_list: this.predictionFilesDescribe,
                model: this.selectedModelInfo.id,
                run: false,
                patient_name: this.patient_name
            }
            this.$store.dispatch('modelsUsingForAiDashFun', data)
        },
        validArrCheckOfValueMethod(val) {
            return Array.isArray(val)
        }
    }
}
</script>

<style lang="scss" scoped>
.patient_selection_form_inner {
    .model_trained_loader {
        display: inline-block;
        margin-left: 15px;

        .img-fluid {
            width: 28px;
        }
    }
}

.prediction_files_option_wrp {
    option {
        color: #000000;
    }
}

.model_predict_form_box {
    background: rgba(255, 255, 255, 0.01);
    padding: 20px;
    border: 1px solid rgba(255, 255, 255, 0.05);
    border-radius: 10px;
    margin-top: 30px;

    label {
        font-size: 18px;
        margin-bottom: 5px;
        color: #efefef;
    }

    .form-control {
        width: 100%;
        height: 44px;
        font-weight: 400;
        font-size: 18px;
        border-radius: 5px;
        padding: 0px 20px;
        border: 1px solid rgba(255, 255, 255, 0.1);
        outline: none !important;
        -webkit-box-shadow: none !important;
        box-shadow: none !important;
        color: #ffd400;
        background: rgba(255, 255, 255, 0.08);

        &:focus {
            border-color: #ffd400;
        }
    }

    .invalid-feedback {
        font-size: 14px;
        line-height: 1;
        font-weight: 600;
        color: #ff3a30;
    }

    .btn-primary {
        cursor: pointer;
        position: relative;
        min-width: 95px;
        box-shadow: none !important;
        outline: none !important;
        background: rgba(255,18,18,.5)!important;
        color: #ffffff !important;
        border: none !important;
        border-radius: 3px;
        font-family: 'MyriadProRegular', 'Lato', sans-serif;
        font-size: 18px;

        &:hover {
            background: #87cefa !important;
            color: #22292f !important;
        }
    }
}

.predication_output_box_inner {
    background: rgba(122, 255, 124, 0.16);
    border: 1px solid rgba(122, 255, 124, 0.16);
    padding: 15px;
    border-radius: 10px;
    margin-top: 30px;

    .predication_output_heading {
        color: #fffcc4;
        text-transform: capitalize;
        font-size: 20px;
        font-weight: normal;

        span {
            color: #42e344;
            font-size: 22px;
        }
    }

    .btn-success {
        color: #fffcc4 !important;
        font-size: 16px;
        box-shadow: none !important;
        background: rgba(255, 18, 18, 0.5) !important;
        border: none !important;

        &:hover {
            background: #ffe738 !important;
            color: #22292f !important;
        }
    }

    &.radius_bg {
        background: rgba(255, 179, 168, 0.16);
        border-color: rgba(255, 146, 131, 0.16);

        .predication_output_heading {
            span {
                color: #ff7661;
            }
        }

        .btn-success {
            color: #d8d7be !important;
            background: rgba(0, 237, 49, 0.5) !important;

            &:hover {
                background: #87cefa !important;
                color: #22292f !important;
            }
        }
    }
}

.edit_field_btn {
    border: none;
    background: #5a0c60 !important;
    color: #fffcc4 !important;
    padding: 8px 20px;
    line-height: 1;
    font-size: 16px;
    box-shadow: none !important;

    &:hover {
        background: #87cefa !important;
        color: #22292f !important;
    }
}

.btn-primary {
    padding: 8px 35px;
    height: auto;
    font-size: 16px;
    border-radius: 70px;
    background: rgba(255, 255, 255, 0.12) !important;
    color: #ffffff !important;
    border: none !important;
    text-transform: capitalize;
    transition: all ease 0.5s;
    -webkit-transition: all ease 0.5s;
    -moz-transition: all ease 0.5s;
    box-shadow: none !important;
    letter-spacing: 1px;

    &:hover {
        background: #87cefa !important;
        color: #22292f !important;
    }
}
</style>